export default {
    /* GET_USER_DEPARTMENTS
    ---------------------------------------------------------------
    */
    GET_PRODUCTION_DEPARTMENTS: (state, data) => {
        state.productionDepartments = data.results
    },
    GET_STOP_CARD_PRODUCTION_DEPARTMENTS: (state, data) => {
        state.stopCardProductionDepartments = data.results
    },
    /* GET_USERS
    ---------------------------------------------------------------
    */
    GET_USERS_REQUEST: state => {
        state.usersLoading = true
    },
    GET_USERS_SUCCESS: (state, data) => {
        state.users = data.results
        state.usersLoading = false
    },
    GET_USERS_FAILURE: state => {
        state.usersLoading = false
    },

    /* GET_MACHINES
    ---------------------------------------------------------------
    */
    GET_MACHINES_SUCCESS: (state, data) => {
        state.machines = data.results
    },

    SAVE_USER: (state, data) => {
        const index = state.users.findIndex(item => item.id == data.id)

        state.users[index] = data
    },

    SET_USERS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    /* GET_USER_POSITIONS
    ---------------------------------------------------------------
    */
    GET_USER_POSITIONS_SUCCESS: (state, data) => {
        state.positions = data
    },
    /* GET_USER_SQUADS
    ---------------------------------------------------------------
    */
    GET_USER_SQUADS_SUCCESS: (state, data) => {
        state.squads = data
    },
    CLEAR_USERS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    },
    /* GET_USER_PREMISSION_ROLES
    ---------------------------------------------------------------
    */
    GET_USER_ROLES_SUCCESS: (state, data) => {
        state.roles = data
    },
}
